import { useSelector } from 'react-redux'
import useSlug from 'hooks/useSlug'
import { selectUser } from 'store/api'
import api from 'store/api/reducer'

export const useAccountUser = () => {
  const { queryLng } = useSlug()

  const user = useSelector(selectUser(queryLng))
  const { isFetching, isError } =
    api.endpoints.getUserInfo.useQueryState(queryLng)

  const isLoading = isFetching && !user?.phone && !user?.email

  return {
    user,
    isLoading,
    isError,
  }
}
